import { call, put, takeEvery } from 'redux-saga/effects';
import { CREATE_USER_EMAIL_REQUEST } from '../../constants/user_emails.constants';
import { createUserEmail } from '../../../requests/user_emails_requests/create_user_email_request';
import { createUserEmailRequestSuccess, createUserEmailRequestFailure } from '../../actions/user_emails_actions/create_user_email.actions';
import { message_success, message_error } from '../../../../../../components/Message';

function* createUserEmailRequest({ id, email, name }) {
    const {
        result, error, msg, options,
    } = yield call(createUserEmail, id, email, name);
    if (result) {
        yield put(createUserEmailRequestSuccess(options.person.emails));
        message_success('Email created successfully!');
    } else {
        yield put(createUserEmailRequestFailure(error));
        message_error(msg);
    }
}

export default function* createUserEmailSaga() {
    yield takeEvery(CREATE_USER_EMAIL_REQUEST, createUserEmailRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_emails_sagas/create_user_email.saga.js